import React, { Component } from "react";
import PropTypes from "prop-types";
import "bootstrap";
import { connect } from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import formatData, { formatMnDate } from "@mnjsplatform/data/lib/utils/formatData";
import {navigateCommand} from "../Navigation/Routes"
import { withRouter } from 'react-router';
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import DocumentStatusImage from "@mnjsplatform/components/lib/common/DocumentStatusImage";
import {buildReport} from "@mnjsplatform/data/lib/actions/reportActions";
import ReportBuildViewer from "@mnjsplatform/components/lib/common/Reports/ReportBuildViewer";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";

class ServicesActs extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isLoading: true,
      isEditorOpen: false,
      isEditorAdd: false
    };
  }

  componentDidMount() {
    this.setState({"isLoading": true});

    //let params = {BeginDate: "01.01.2016"};
    this.props.dispatch(this.props.servicesActsList.execute({}, {withParams: true}))
                .finally(() => this.setState({"isLoading": false}));
  }

  onRefreshFormClick = async() => {
    await this.props.dispatch(this.props.servicesActsList.refresh());
  };

  onCreateActClick = () => {
    this.props.dispatch(this.props.servicesActsCreate.reset())
            .then(() => { return this.props.dispatch(this.props.servicesActsCreate.initialize({}, {withParams: true, refresh: false, newItem: true})) })
            .then(() => { this.setState({isEditorOpen: true, isEditorAdd: true}) });
  };

  onEditActPropsClick = (rowIndex) => {

    let params = { Document_Object: this.props.servicesActsList.getField(rowIndex, "Document_Object"),
                   DocumentDate: this.props.servicesActsList.getField(rowIndex, "DocumentDate"),
                   DocumentNumber: this.props.servicesActsList.getField(rowIndex, "DocumentNumber")};

    this.props.dispatch(this.props.servicesActsUpdate.reset())
      .then(() => { return this.props.dispatch(this.props.servicesActsUpdate.initialize(params, {withParams: true, refresh: false, newItem: true})) })
      .then(() => { this.setState({isEditorOpen: true, isEditorAdd: false}) });
  };

  onSendActClick = (rowIndex) => {

    let params = { Document_Object: this.props.servicesActsList.getField(rowIndex, "Document_Object"),
                   DocumentDate: this.props.servicesActsList.getField(rowIndex, "DocumentDate"),
                   DocumentNumber: this.props.servicesActsList.getField(rowIndex, "DocumentNumber")};

    confirm(i18next.t("SendAct"))
      .then(async() => {
        await this.props.dispatch(this.props.servicesActsSend.execute(params));
        await this.props.dispatch(this.props.servicesActsList.refresh());
      });
  };

  onDeleteActClick = (rowIndex) => {

    let params = { Document_Object: this.props.servicesActsList.getField(rowIndex, "Document_Object"),
      DocumentDate: this.props.servicesActsList.getField(rowIndex, "DocumentDate"),
      DocumentNumber: this.props.servicesActsList.getField(rowIndex, "DocumentNumber")};

    confirm(i18next.t("RemoveAct"))
      .then(async() => {
        await this.props.dispatch(this.props.servicesActsDelete.execute(params));
        await this.props.dispatch(this.props.servicesActsList.refresh());
      });
  };

  onPrintActReestrClick = (rowIndex) => {
    const reportId = "TDDistWListDocs";

    this.props.dispatch(buildReport(reportId, this.props.servicesActsList.getRow(rowIndex)));
  };

  onEditActClick = (rowIndex) => {
    this.editAct(this.props.servicesActsList.getField(rowIndex, "DocumentIntId"));
  };

  editAct = (DocumentIntId) => {
    if (!DocumentIntId) {
      return;
    }
    navigateCommand(this.props.history, "WEB_API_ServicesActsEdit", {DocumentIntId});
  };

  onSaveServicesActAdd = async() => {
    await this.props.dispatch(this.props.servicesActsCreate.applyParams(this.props.servicesActsCreateParams));
    if (!this.props.servicesActsCreate.isError) {
      this.editAct(this.props.servicesActsCreate.getField(0, "DocumentIntId"));
    }
  };

  onSaveServicesActEdit = () => {
    this.props.dispatch(this.props.servicesActsUpdate.applyParams(this.props.servicesActsUpdateParams))
      .then(()=>{
        if (!this.props.servicesActsUpdate.isError)
          return this.props.dispatch(this.props.servicesActsList.refresh());
        else return Promise.reject();
      })
      .then(()=>this.setState({isEditorOpen: false}))
      .catch(()=>{});
  };

  onCloseEditor = () => {
    this.setState({isEditorOpen: false})
  };

  renderParams = (h) => {

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-md-3">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("InterCompanyName")}
            </div>
            <div>
              {h.ed("InterCompanyName")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("BeginDate")}
            </div>
            <div>
              {h.ed("BeginDate")}
            </div>
          </div>
          <div className="col-md-2">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("EndDate")}
            </div>
            <div>
              {h.ed("EndDate")}
            </div>
          </div>
          <div className="col-md-3">
            <div className="field-title" style={{textAlign: "left"}}>
              {h.lbl("StatusName")}
            </div>
            <div>
              {h.ed("StatusName")}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-10">
            <div className="field-title text-left">
              {i18next.t("SearchLabel")}
            </div>
            <div>
              <SearchBar dataItem={this.props.servicesActsList} />
            </div>
          </div>
        </div>
      </React.Fragment>);
  };

  renderEditor = () => {
    if(!this.state.isEditorOpen)
      return null;

    const isEditorAdd = this.state.isEditorAdd;

    const title = isEditorAdd ? i18next.t('CreateServicesAct') : i18next.t('EditServiceAct');
    const applyButtonText = isEditorAdd ? i18next.t('Create') : i18next.t('Save');
    const item = isEditorAdd ? this.props.servicesActsCreateParams : this.props.servicesActsUpdateParams;
    const saveFunc = isEditorAdd ? this.onSaveServicesActAdd : this.onSaveServicesActEdit;
    const parentDataItem = isEditorAdd ? this.props.servicesActsCreate : this.props.servicesActsUpdate;

    const renderButtons = () => {
      return (<div className="modal-footer text-right">
        <div className="text-right">
          <button className="btn btn-regular" onClick={saveFunc}>{applyButtonText}</button>
          &nbsp;
          <button className="btn btn-regular" onClick={this.onCloseEditor}>{i18next.t('Cancel')}</button>
        </div>
      </div>);
    };

    return (
      <PopupWrapper popupVisible title={title}
                          onClose={this.onCloseEditor}
                          renderButtons={renderButtons}>
        <ComplexParam dataItem={item} rootPath="/"
                    renderParams={this.renderEditorParams} parentDataItem={parentDataItem}
                    rowIndex={0} />
      </PopupWrapper>);
  };

  renderEditorParams = (h) => {
    return (<div className="row" style={{minHeight: '400px'}}>
      <div className="col-md-12">
        {h.fs.map((fi) => {

          const fn = fi.Name;

          return (<React.Fragment key={fn}>

            <div className="row">
              <div className="col-md-3 field-title">
                {h.lbl(fn)}
              </div>
              <div className="col-md-9">
                {h.ed(fn)}
              </div>
            </div>
            <hr/>
          </React.Fragment>)
        })}

      </div>
    </div>)
  };

  renderCommandButtons = (row, rowIndex) => {

    let allowEdit = row["AllowEdit"] === 1;
    let allowEditProps = row["AllowEditProps"] === 1;
    let allowSend = row["AllowSend"] === 1;
    let allowDelete = row["AllowDelete"] === 1;
    let allowReestrPrint = row["AllowPrint"] === 1;
    let editButtonText = allowEdit ? i18next.t("EditButton") : i18next.t("ViewButton");

    let buttons = {};

    buttons[0] = {text: editButtonText, callback: this.onEditActClick, className: "btn btn-regular btn-carrier-action -goahead"};

    if(allowEditProps)
      buttons[1] = {text: i18next.t("ChangeRequisitesButton"), callback: this.onEditActPropsClick, className: "btn btn-regular btn-carrier-action"};

    if(allowSend)
      buttons[2] = {text: i18next.t("SendButton"), callback: this.onSendActClick, className: "btn btn-regular btn-carrier-action -goescape"};

    if(allowDelete)
      buttons[3] = {text: i18next.t("RemoveButton"), callback: this.onDeleteActClick, className: "btn btn-regular btn-carrier-action"};

    if(allowReestrPrint)
      buttons[4] = {text: i18next.t("PrintRegistryButton"), callback: this.onPrintActReestrClick, className: "btn btn-regular btn-carrier-action"};

    let buttonArray = Object.values(buttons);

    return(
      <React.Fragment>
        <div className="row" style={{marginTop: "20px", marginBottom: "10px"}}>
          {
            buttonArray.map((item, index) => {

              if(index > 1)
                return null;

              return (
                <div className="column col-md-6" style={{textAlign: "left"}}>
                  <button type="button" style={{width: "100%"}} className={item.className} onClick={() => {item.callback(rowIndex)}}>
                    {item.text}
                  </button>
                </div>);
            }, this)
          }
        </div>
        {buttonArray.length > 2 &&
        <div className="row" style={{marginTop: "20px", marginBottom: "10px"}}>
          {
            buttonArray.map((item, index) => {

              if(index < 2)
                return null;

              return (
                <div className="column col-md-6" style={{textAlign: "left"}}>
                  <button type="button" style={{width: "100%"}} className={item.className} onClick={() => {item.callback(rowIndex)}}>
                    {item.text}
                  </button>
                </div>);
            }, this)
          }
        </div>
        }
      </React.Fragment>
    );
  };

  renderRow = (row, rowIndex, renderRowDefault, dataItem, fiMap) => {

    let actNumber = row["DocumentNumber"];
    let actDate = formatMnDate(row.DocumentDate);

    return (
      <div className="col-md-4" style={{paddingLeft: '0px', paddingRight: '0px'}}>
        <div className="col-md-12">
          <div className="card -cdoc mt20">
            <div className="card-header">
              <div className="row">
                <div className="col-md-12" style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap', width: '100%'}}>
                  <h6 style={{display: "inline-block", marginBottom: '0px'}}>
                    {i18next.t("ActTitle", { number: actNumber, date: actDate })}</h6>
                  <DocumentStatusImage statusChar={row.CurrentStatus} style={{ marginRight: "0px", display: "inline-block"}}/>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="row fs15">
                <div className="column col-md-12" style={{backgroundColor: "green"}}>
                  <span style={{color: "#FFF"}}>
                    {row.InterCompanyName}&nbsp;
                  </span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-5">
                  <span className="field-title">{i18next.t("ContractDate")}:</span>
                  <span>&nbsp;{formatMnDate(row.ContractDate)}</span>
                </div>
                <div className="column col-md-7">
                  <span className="field-title">{i18next.t("ContractNumber")}:</span>
                  <span>&nbsp;{row["ContractNumber"]}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-5">
                  <span className="field-title">{i18next.t("BillDate")}:</span>
                  <span>&nbsp;{formatMnDate(row.ActionDate)}</span>
                </div>
                <div className="column col-md-7">
                  <span className="field-title">{i18next.t("BillNumber")}:</span>
                  <span>&nbsp;{row["SrcDocumentNumber"]}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-5">
                  <span className="field-title">{i18next.t("TotalWithoutFees")}:</span>
                  <span>&nbsp;{formatData(fiMap["Summ"], row["Summ"])}</span>
                </div>
                <div className="column col-md-7">
                  <span className="field-title">{i18next.t("PayKindName")}:</span>
                  <span>&nbsp;{row["PayKindName"]}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{i18next.t("TCComment")}:</span>
                  <span>&nbsp;{row["Subject1"]}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{i18next.t("BaltikaComment")}:</span>
                  <span>&nbsp;{row["Subject2"]}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{i18next.t("TCEmail")}:</span>
                  <span>&nbsp;{row["TCEMail"]}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{i18next.t("Status")}:</span>
                  <span>&nbsp;{row["StatusName"]}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{i18next.t("AcceptDate")}:</span>
                  <span>&nbsp;{formatMnDate(row.ExtInvoiceAcceptDate)}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{i18next.t("FinanceDate")}:</span>
                  <span>&nbsp;{formatMnDate(row.FinLiabActionDate)}</span>
                </div>
              </div>
              <div className="row fs15">
                <div className="column col-md-12">
                  <span className="field-title">{i18next.t("PayDate")}:</span>
                  <span>&nbsp;{formatMnDate(row.FinLiabPaymentDate)}</span>
                </div>
              </div>
              {row.IsECMVendUpdRequired === 1 &&
              <div className="row fs15">
                <div className="column col-md-12">
                  <span style={{ color: "red", fontWeight: 'bold' }}>{i18next.t("NeedToCreateEUTD")}</span>
                </div>
              </div>
              }
              {this.renderCommandButtons(row, rowIndex)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {

    if(this.state.isLoading)
      return null;

    const fiMap = {};
    this.props.servicesActsList.rawData.ResultFieldInfo.forEach((item) => {
      fiMap[item.Name] = item;
    });

    return (
      <React.Fragment>
        <ReportBuildViewer/>
        <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
          <div className="col-md-9">
            <h1 className="page-title" style={{display: 'inline-block', marginRight: '25px'}}>
              {i18next.t("ServicesActsTitle")}
            </h1>
            <button className="btn btn-regular btn-carrier-action -goahead" onClick={this.onRefreshFormClick}>{i18next.t("RefreshData")}</button>
          </div>
          <div className="col-md-3" style={{textAlign: "right"}}>
            <button type="button" className="btn btn-regular btn-carrier-action -goescape" onClick={this.onCreateActClick}>
              {i18next.t("CreateButton")}
            </button>
          </div>
        </div>

        <ComplexParam dataItem={this.props.servicesActsListParams} readOnly={false} showSearchBar={false}
                      showApplyButton={false} rootPath="/" parentDataItem={this.props.servicesActsList} renderParams={this.renderParams}
                      autoApplyParams={true}
        />

        <div className="row">{this.props.servicesActsList
                              && this.props.servicesActsList.rowsCount() > 0
                                ? <span className={"col-md-12"} style={{fontWeight: 'bold'}}>{i18next.t("AllActsCount")}:&nbsp;{this.props.servicesActsList.rowsCount()}</span>
                                : <span>&nbsp;</span>}
        </div>

        <div style={{marginLeft: "-15px", marginRight: "-15px"}}>
          <GridView dataItem={this.props.servicesActsList}
                    allowPagination
                    activePageSize={12}
                    pageSize={12}
                    renderRow={(row, rowIndex, renderRowDefault, dataItem) => this.renderRow(row, rowIndex, renderRowDefault, dataItem, fiMap)}
                    showHeader={false}
                    flexBox
                    flexBoxWidthPercent={100}/>
        </div>
        {this.renderEditor()}
      </React.Fragment>
    );
  }
}

ServicesActs.propTypes = {
  dispatch: PropTypes.func.isRequired
};


ServicesActs.defaultProps = {
  //myProp: <defaultValue>
};

function mapStateToProps(state, ownProps) {
  return {
    servicesActsList: state.servicesActsState.servicesActsList,
    servicesActsListParams: state.servicesActsState.servicesActsListParams,
    servicesActsCreate: state.servicesActsState.servicesActsCreate,
    servicesActsCreateParams: state.servicesActsState.servicesActsCreateParams,
    servicesActsSend: state.servicesActsState.servicesActsSend,
    servicesActsDelete: state.servicesActsState.servicesActsDelete,
    servicesActsUpdate: state.servicesActsState.servicesActsUpdate,
    servicesActsUpdateParams: state.servicesActsState.servicesActsUpdateParams,
  };
}

export default withRouter(connect(mapStateToProps)(ServicesActs));